export class PaytmPaymentDto {

    refNo: string;
    linkId: string;
    orderId: string;
    customerCode: string;
    fromLocationCode: number;
    amount: number = 0;
}
